/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useState } from 'react';
import Button from '../button/Button';
import styles from './multi-value-input.module.scss'

interface IProps {
  list: Array<any>
  modifiers?: string
  label: string
  name: string
  readOnly?: boolean
  disabled?: boolean
  selectedValues?: Array<any>
  updateList: any
  placeholder: string
}

const MultiValueInput = React.memo(function (props: IProps) {
  const [inputValue, setInputValue] = useState('')
  const [list, updateList] = useState(props.list)
  const [selectedValues, updateSelectedValues] = useState([])
  const [focused, setFocused] = useState(false)
  const container = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (props.selectedValues) {
      updateSelectedValues(props.selectedValues)
    }
  }, [props.selectedValues])


  useEffect(() => {
    if (props.list) {
      updateList(props.list)
    }
  }, [props.list])

  useEffect(() => {
    window.addEventListener('click', clickedOuSide)
    return () => window.removeEventListener('click', clickedOuSide)
  }, [])

  const handleChange = (value: string) => {
    setInputValue(value)
    updateList([...props.list].filter(v => (`${v.firstName} ${v.lastName}`).toLowerCase().includes(value.toLowerCase())))
  }


  const handleClick = (value: any) => {
    if (!selectedValues.find(v => value.id === v.id)) {
      updateSelectedValues([...selectedValues, value])
      props.updateList([...selectedValues, value])
    } else {
      const values = [...selectedValues]
      const index = selectedValues.findIndex((v: any) => v.id === value.id)
      values.splice(index, 1)
      updateSelectedValues(values)
      props.updateList(values)
    }
  }

  const clickedOuSide = (e: any) => {
    if (container.current && !container.current.contains(e.target)) {
      setFocused(false)
    }
  }

  const removeSelectedValue = (value: any) => {
    const values = [...selectedValues]
    const index = selectedValues.findIndex((v: any) => v.id === value.id)
    values.splice(index, 1)
    setTimeout(function () {
      updateSelectedValues(values)
      props.updateList(values)
    }, 0);
  }

  return (
    <>
      <div className={`${styles.inputField} ${props.modifiers ? props.modifiers : ''}`} ref={container}>
        {props.label && <label htmlFor={props.name} className={styles.inputLabel}>{props.label}</label>}
        <div className={`${styles.inputWrapper} ${focused ? styles.focused : ''}`}>
          <input
            id={props.name}
            className={styles.input}
            placeholder={props.placeholder}
            type={'text'}
            onClick={() => setFocused(!focused)}
            disabled={props.disabled}
            autoComplete='off'
            readOnly={props.readOnly}
            value={inputValue}
            onChange={(e: any) => handleChange(e.target.value)}
          />
          {focused && !props.disabled && <ul className={styles.list}>
            {list && list.length > 0 ?
              list.map((suggestion, index) => {
                return (
                  <li className={styles.item} key={index} onClick={() => handleClick(suggestion)}>
                    {`${suggestion.firstName} ${suggestion.lastName}`}
                    {selectedValues.find(v => suggestion.id === v.id) && <svg xmlns="http://www.w3.org/2000/svg" className="tw-ml-auto tw-h-5 tw-w-5" viewBox="0 0 20 20" fill="#2bab66">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>}
                  </li>
                )
              }) :
              <li className={styles.item}>Ingen resultater fundet</li>}
          </ul>}
          <span className={styles.dropDownIcon} onClick={() => setFocused(!focused)}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          </span>
        </div>
        <div className='tw-flex tw-flex-wrap tw-mt-2'>
          {selectedValues.map((value, index) => <Button modifiers='tw-mr-3 tw-mb-3' key={index} handleClick={() => removeSelectedValue(value)} type='addon' size='small' label={`${value.firstName} ${value.lastName}`} iconLeft={<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
          </svg>} />)}
        </div>
      </div >
    </>
  )
})


export default MultiValueInput
